// Executive-protected role detection (mirror of /app/backend/xray_generator/_exec_protected.py).
// Used by the X-Ray template safety net: AVP/VP/SVP/Chief/CIO/CISO/CTO candidates must
// never display Restructuring tier or Exit/Reposition verdicts.

const EXEC_TITLE_RE = new RegExp(
  [
    "\\bAVP\\b",
    "\\bVP\\b",
    "\\bSVP\\b",
    "\\bEVP\\b",
    "\\bChief\\b",
    "\\bCIO\\b",
    "\\bCISO\\b",
    "\\bCTO\\b",
    "\\bCEO\\b",
    "\\bCOO\\b",
    "\\bCFO\\b",
    "Vice President",
    "Senior Vice President",
    "Assistant Vice President",
    "Executive Vice President",
  ].join("|"),
  "i"
);

export const FORBIDDEN_TIERS = new Set(["Restructuring Candidate"]);
export const FORBIDDEN_VERDICTS = new Set([
  "EXIT", "Exit", "REPOSITION", "Reposition", "REDEPLOY", "TRANSITION",
]);
export const FORBIDDEN_DISPOSITIONS = new Set([
  "Reassign", "Transition", "Exit", "Reposition",
]);

export const SAFE_TIER_DEFAULT = "No Data";
export const SAFE_VERDICT_DEFAULT = "STABILISE & MONITOR";
export const SAFE_DISPOSITION_DEFAULT = "Develop";

export function isExecutiveRole(role) {
  if (!role || typeof role !== "string") return false;
  return EXEC_TITLE_RE.test(role);
}

/**
 * Returns { protected: bool, scrubbed: bool, body } — if the candidate is exec-protected
 * AND any forbidden tier/verdict/disposition is present, returns a body with those values
 * replaced by safe defaults plus scrubbed=true so the UI can show a protected-class note.
 */
export function applyExecutiveSafetyNet(body) {
  if (!body || typeof body !== "object") return { protected: false, scrubbed: false, body };
  const role = body?.identity?.role;
  if (!isExecutiveRole(role)) return { protected: false, scrubbed: false, body };

  let scrubbed = false;
  const safe = { ...body, identity: { ...(body.identity || {}) }, intelligence: { ...(body.intelligence || {}) } };
  safe.intelligence.bri = { ...(safe.intelligence.bri || {}) };
  safe.intelligence.operationalCategory = { ...(safe.intelligence.operationalCategory || {}) };

  if (FORBIDDEN_TIERS.has(safe.intelligence.bri.tier)) {
    safe.intelligence.bri.tier = SAFE_TIER_DEFAULT;
    scrubbed = true;
  }
  if (FORBIDDEN_VERDICTS.has(safe.identity.assessmentVerdict)) {
    safe.identity.assessmentVerdict = SAFE_VERDICT_DEFAULT;
    scrubbed = true;
  }
  if (FORBIDDEN_DISPOSITIONS.has(safe.intelligence.operationalCategory.verdict)) {
    safe.intelligence.operationalCategory.verdict = SAFE_DISPOSITION_DEFAULT;
    scrubbed = true;
  }
  // Builder path q4 target (Phase 1e)
  if (safe.builder_path && typeof safe.builder_path === "object") {
    const q4 = safe.builder_path.q4_target_tier || safe.builder_path.q4_target;
    if (FORBIDDEN_TIERS.has(q4) || q4 === "Pending decision") {
      safe.builder_path = { ...safe.builder_path, q4_target_tier: safe.intelligence.bri.tier || SAFE_TIER_DEFAULT };
      scrubbed = true;
    }
  }
  return { protected: true, scrubbed, body: safe };
}
